import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const accountCustomersRoutes = [
  {
    path: 'customers',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Customers')
      },
      permissions: ['READ_CUSTOMERS']
    },
    children: [
      {
        path: '',
        name: 'customersList',
        component: wrapLegacyRoute('customersController', 'list')
      },
      {
        path: 'create',
        name: 'customerCreate',
        component: wrapLegacyRoute('customersController', 'create')
      },
      {
        path: ':customerId(\\d+)',
        name: 'customerDetails',
        component: wrapLegacyRoute('customersController', 'details')
      }
    ]
  }
];

export default accountCustomersRoutes;
